export const onDialogConfirmConfirmItem = () => ({
  widget: 'models',
  type: 'onDialogConfirmConfirmItem',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogConfirmConfirmItem.js